<template>
  <div>
    <Form :model="setting"
          :rules="rules"
          :label-width="200">
      <FormItem :label="$t('pages_first_order_discount_index_501')" style="max-width: 700px">
        <i-input
         v-model="setting.first_order_discount" @on-blur="change_first_order_discount" :placeholder="$t('pages_first_order_discount_index_501')" />
      </FormItem>
      <FormItem :label="$t('pages_first_order_discount_index_502')">
        <i-switch v-model="setting.first_order_discount_open"
                  size="large"
                  @on-change="change_first_order_discount_open">
          <span slot="open">{{$t('pages_birthday_discount_index_208')}}</span>
          <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
        </i-switch>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: {},
  data () {
    return {
      rules: {
        customer_score_rate: [
          {
            validator: (rule, value, callback) => {
              if (!value) return callback()
              if (value < 0) return callback(new Error(i18n.t('pages_birthday_discount_index_210')))
              callback()
            },
          }
        ]
      }
    }
  },
  created () {
    this.display()
    this.fetchPackages({ page: 1, per: 65536 });
    this.fetchBarcodes({ page: 1, per: 65536 });
  },
  computed: {
    ...mapGetters('setting', ['setting']),
    ...mapState('package', ['packages']),
    ...mapState('bar_code', ['bar_codes']),
    selectedPkg () {
      const id = this.setting.package_id;
      const pkg = this.packages.find(i => i.id === id);
      return pkg || {};
    },
  },
  methods: {
    ...mapActions('setting', ['display', 'upgrade']),
    ...mapActions('package', {
      fetchPackages: 'index'
    }),
    ...mapActions('bar_code', {
      fetchBarcodes: 'index'
    }),
    change () {
      this.upgrade({ ticket_qr_show: this.setting.ticket_qr_show })
    },
    change_sms_open () {
      this.upgrade({ vip_sms_open: this.setting.vip_sms_open })
    },
    change_open_wechat_facepay () {
      this.upgrade({ open_wechat_facepay: this.setting.open_wechat_facepay })
    },
    change_open_alipay_facepay () {
      this.upgrade({ open_alipay_facepay: this.setting.open_alipay_facepay })
    },
    change_show_mp () {
      this.upgrade({ show_mp: this.setting.show_mp })
    },
    change_first_order_discount () {
      this.upgrade({ first_order_discount: this.setting.first_order_discount })
    },
    change_first_order_discount_open () {
      this.upgrade({ first_order_discount_open: this.setting.first_order_discount_open })
    },
    change_zero_stock_sale () {
      this.upgrade({ zero_stock_sale: this.setting.zero_stock_sale })
    },
    change_customer_score_open () {
      this.upgrade({ customer_score_open: this.setting.customer_score_open })
    },
    change_customer_score_rate () {
      const rate = Math.round(this.setting.customer_score_rate * 100) / 100;
      this.setting.customer_score_rate = rate;
      this.upgrade({ customer_score_rate: rate });
    },
    async change_discount_order () {
      await this.upgrade({ discount_order: this.setting.discount_order })
      this.display();
    },
    async saveSecondCardRate () {
      await this.upgrade({ second_card_rate: parseFloat(this.setting.second_card_rate) });
    },
    async savePackageId () {
      await this.upgrade({ package_id: parseFloat(this.setting.package_id) });
    },
    async saveBarcodeId () {
      await this.upgrade({ bar_code_id: parseFloat(this.setting.bar_code_id) });
    },
    async saveWarmTips () {
      await this.upgrade({ warm_tips: this.setting.warm_tips });
    },
    async saveShopCode () {
      await this.upgrade({ shop_code: this.setting.shop_code });
    },
    async saveAlipayMerchantNo () {
      await this.upgrade({ alipay_merchant_no: this.setting.alipay_merchant_no });
    },
    async saveSecondCardName () {
      await this.upgrade({ second_card_name: this.setting.second_card_name });
    },
    async saveVirtualWeight () {
      await this.upgrade({ show_virtual_weight: this.setting.show_virtual_weight });
    },
    getDiscountRowOrder (order) {
      return order;
    },
    renderDiscountItem (order) {
      const orderText = {
        huiyuanjia: i18n.t('pages_ai_thirdparty_167'),
        special_price: i18n.t('pages_birthday_discount_index_211'),
      }[order]
      return orderText || order;
    }
  }
}
</script>
